import { render } from "./wordTree.vue?vue&type=template&id=ce4ea728"
import script from "./wordTree.vue?vue&type=script&lang=js"
export * from "./wordTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__